let busy = false;

const next = _.debounce(function () {
    if (busy) {
        return _.defer(next);
    }

    let answer = _(app.store.getState().forms.uploading).first();
    if (answer) {
        busy = true;

        console.log('Uploading form answer: ', answer.UID, answer);
        app.api.forms
            .sendAnswer(answer.UID, answer.formId, {
                event_id: answer.eventId,
                answers: _(answer.answers)
                    .map((values, formquestion_id) => {
                        return _(values)
                            .map(value => ({formquestion_id, value}))
                            .value();
                    })
                    .flatten()
                    .value(),
            })
            .catch(err => {
                console.error(err);
            })
            .then(() => {
                busy = false;
                next();
            });
    }
}, 2500);

_.defer(() => {
    let unsubscribe = app.store.observe(state => state.forms.uploading, next);
    app.onShutdown(unsubscribe);
});
